import { OWListener, OWListenerDelegate } from './common/ow-listener';

// -----------------------------------------------------------------------------
export interface OWGameListenerDelegate extends OWListenerDelegate {
  onGameStarted?(info: overwolf.games.RunningGameInfo);
  onGameEnded?(info: overwolf.games.RunningGameInfo);
  onGameTerminated?(info: overwolf.games.GameInfoUpdatedEvent);
}

// -----------------------------------------------------------------------------
export class OWGameListener extends OWListener<OWGameListenerDelegate> {
  private onTerminatedFunc: any;
  // ---------------------------------------------------------------------------
  constructor(delegate: OWGameListenerDelegate, autoStart = false) {
    super(delegate);

    if (autoStart) {
      this.start();
    }
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    // This calls |stop|
    super.start();
    this.onTerminatedFunc = this.onGameTerminated.bind(this);
    overwolf.games.onGameInfoUpdated.addListener(this.onGameInfoUpdated);
    overwolf.games.tracked.onTerminated.addListener(this.onTerminatedFunc);

    // Perform current check
    overwolf.games.getRunningGameInfo(this.onRunningGameInfo);
  }

  // ---------------------------------------------------------------------------
  public stop(): void {
    overwolf.games.onGameInfoUpdated.removeListener(this.onGameInfoUpdated);
    overwolf.games.tracked.onTerminated.removeListener(this.onTerminatedFunc);
  }

  // ---------------------------------------------------------------------------
  private onGameInfoUpdated = (
    update: overwolf.games.GameInfoUpdatedEvent,
  ): void => {
    if (!update || !update.gameInfo) {
      return;
    }

    if (!update.runningChanged && !update.gameChanged) {
      return;
    }

    if (update.gameInfo.isRunning) {
      if (this._delegate.onGameStarted) {
        this._delegate.onGameStarted(update.gameInfo);
      }
    } else {
      if (this._delegate.onGameEnded) {
        this._delegate.onGameEnded(update.gameInfo);
      }
    }
  };

  // ---------------------------------------------------------------------------
  private onRunningGameInfo = (info: overwolf.games.RunningGameInfo): void => {
    if (!info) {
      return;
    }

    if (info.isRunning) {
      if (this._delegate.onGameStarted) {
        this._delegate.onGameStarted(info);
      }
    }
  };

  // ---------------------------------------------------------------------------
  private onGameTerminated = (
    info: overwolf.games.GameInfoUpdatedEvent,
  ): void => {
    if (!info || !info.gameInfo) {
      return;
    }

    if (this._delegate.onGameTerminated) {
      this._delegate.onGameTerminated(info);
    }
  };
}
